export default __webpack_public_path__ + "static/media/f-limpieza-y-cuidado.85a11799.png";